import React from "react";

const SearchCategories = () => {
  const firstSlideData = [
    {
      s1Name: "Pizza",
      s1img:
        "https://b.zmtcdn.com/data/o2_assets/d0bd7c9405ac87f6aa65e31fe55800941632716575.png",
    },
    {
      s1Name: "Burger",
      s1img:
        "https://b.zmtcdn.com/data/dish_images/ccb7dc2ba2b054419f805da7f05704471634886169.png",
    },
    {
      s1Name: "Sandwich",
      s1img:
        "https://b.zmtcdn.com/data/o2_assets/fc641efbb73b10484257f295ef0b9b981634401116.png",
    },
    {
      s1Name: "Rolls",
      s1img:
        "https://b.zmtcdn.com/data/dish_images/c2f22c42f7ba90d81440a88449f4e5891634806087.png",
    },
    {
      s1Name: "Chicken",
      s1img:
        "https://b.zmtcdn.com/data/dish_images/197987b7ebcd1ee08f8c25ea4e77e20f1634731334.png",
    },
    {
      s1Name: "Biryani",
      s1img:
        "https://b.zmtcdn.com/data/dish_images/d19a31d42d5913ff129cafd7cec772f81639737697.png",
    },
  ];

  const secondSlider = [
    {
      s2Name: "Cake",
      s2img:
        "https://b.zmtcdn.com/data/dish_images/d5ab931c8c239271de45e1c159af94311634805744.png",
    },
    {
      s2Name: "Thali",
      s2img:
        "https://b.zmtcdn.com/data/o2_assets/52eb9796bb9bcf0eba64c643349e97211634401116.png",
    },
    {
      s2Name: "Noodles",
      s2img:
        "https://b.zmtcdn.com/data/dish_images/91c554bcbbab049353a8808fc970e3b31615960315.png",
    },
    {
      s2Name: "Dosa",
      s2img:
        "https://b.zmtcdn.com/data/o2_assets/8dc39742916ddc369ebeb91928391b931632716660.png",
    },
    {
      s2Name: "Paneer",
      s2img:
        "https://b.zmtcdn.com/data/dish_images/e44c42ff4b60b025225c8691ef9735b11635781903.png",
    },
    {
      s2Name: "Momos",
      s2img:
        "https://b.zmtcdn.com/data/o2_assets/5dbdb72a48cf3192830232f6853735301632716604.png",
    },
  ];
  return (
    <div>
      <div className="conatiner-fluid bg-body-tertiary">
        <div className="row container m-auto py-5">
          <h3>Insipiration for your first order</h3>
          <div
            id="carouselExampleAutoplaying"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <div className="row p-3">
                  {firstSlideData.map((data) => {
                    return (
                      <div
                        className="col-md-2 p-4 mColSearch"
                        key={data.s1Name}
                      >
                        <div>
                          <img
                            src={data.s1img}
                            className="card-img-top rounded-circle"
                            alt="..."
                          />
                          <div className="card-body">
                            <h5
                              style={{ fontSize: "14px" }}
                              className="text-center mt-2"
                            >
                              {data.s1Name}
                            </h5>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="carousel-item">
                <div className="row p-3">
                  {secondSlider.map((data) => {
                    return (
                      <div
                        className="col-md-2 p-4 mColSearch"
                        key={data.s2Name}
                      >
                        <div>
                          <img
                            src={data.s2img}
                            className="card-img-top rounded-circle"
                            alt="..."
                          />
                          <div className="card-body">
                            <h5
                              style={{ fontSize: "14px" }}
                              className="text-center mt-2"
                            >
                              {data.s2Name}
                            </h5>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleAutoplaying"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleAutoplaying"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchCategories;
